import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useSearchResults } from '#src/app/pages/searchV2/shared/searchState';

type Result = ModelHookResult<{
	count: number;
	countLocalized: string;
}>;

export function useTotalResultsText(): Result {
	const results = useSearchResults();
	const { localizeNumber } = useI18n();

	return {
		data: {
			count: results.nbHits,
			countLocalized: useMemo(() => localizeNumber(results.nbHits), [results.nbHits, localizeNumber]),
		},
	};
}
